import React from 'react';
import Accordion from 'react-bootstrap/Accordion'
import { mesasRedondas } from '../DataFiles/mesasRedondas';

 
class MesasRedondas extends React.Component {
    render(){

        
        return (
            <section className="mesas ptb-120">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="partner-title platinum-sponsor">
                                <h3 className="lax" data-lax-preset="driftRight">Mesas redondas</h3>
                            </div>
                        </div>
                    </div>

                    {mesasRedondas.map(mr=>(
                    <div className="row">
                        <div className="col-lg-8 col-sm-12">
                            <div className="mesa-redonda">
                                    <h2>{mr.name}</h2>
                                    <p> {mr.description} </p>
                            </div>
                            <hr/>
                            <div className='mesa-redonda'>
                                <p>Modera: </p> 
                                <h4>{mr.moderador}</h4>
                                <p>{mr.moderador_description} </p>
                                <p>Participan: </p>
                                {mr.participantes.map(participante=>(
                                    <>
                                    <h4>{participante.name} </h4>
                                    <p>{participante.description} </p>
                                    {participante.organizations.map(org=>(
                                        <Accordion >
                                            <Accordion.Item className={'accordion-mesas'} eventKey="0">
                                                <Accordion.Header>{org.name}</Accordion.Header>
                                                <Accordion.Body>
                                                {org.description} 
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>                               
                                        ))}
                                   </>
                                ))}
                                
                            </div>
                        </div>
                    </div>
                    ))}                                                   

                </div>  
                       
            </section>
        );
    }
}
 
export default MesasRedondas;